(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/outcome/assets/javascripts/outcome.js') >= 0) return;  svs.modules.push('/components/pool-betting/outcome/assets/javascripts/outcome.js');
"use strict";

const clx = svs.components.lbUtils.clx;
const Outcome = _ref => {
  let ariaDescribedBy = _ref.ariaDescribedBy,
    ariaLabel = _ref.ariaLabel,
    ariaLabelledBy = _ref.ariaLabelledBy,
    branding = _ref.branding,
    className = _ref.className,
    dataTestId = _ref.dataTestId,
    id = _ref.id,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? true : _ref$isDisabled,
    _ref$isSelected = _ref.isSelected,
    isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
    label = _ref.label,
    onChange = _ref.onChange,
    onClick = _ref.onClick,
    isReadOnly = _ref.isReadOnly,
    value = _ref.value,
    tabIndex = _ref.tabIndex;
  return React.createElement("div", {
    className: clx('pb_outcome', className, {
      ["pg_outcome--".concat(branding)]: branding
    })
  }, React.createElement("input", {
    checked: isSelected,
    className: "sr-only",
    "data-testid": dataTestId,
    disabled: isDisabled,
    id: id,
    name: label,
    onChange: onChange,
    onClick: onClick,
    readOnly: isReadOnly,
    tabIndex: tabIndex,
    type: "checkbox",
    value: value
  }), React.createElement("label", {
    "aria-describedby": ariaDescribedBy,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    htmlFor: id
  }, label));
};
setGlobal('svs.poolBetting.components.outcome.Outcome', Outcome);

 })(window);